export default __webpack_public_path__ + "static/media/galga.70100ef3.png";